module.exports = __webpack_public_path__ + "fonts/Prompt-LightItalic.58b20c7b.ttf";